import React from 'react';
import { NpCoordinationProvider } from './context/NpCoordinationContext';
import { NpCoordinationItemsTable, Filters, TablePagination } from './components';

const NpCoordination = () => {
  return(
    <NpCoordinationProvider>
      <div>
        <Filters />
        <NpCoordinationItemsTable />
        <TablePagination />
      </div>
    </NpCoordinationProvider>
  );
};

export default NpCoordination;
